import { createFileRoute } from '@tanstack/react-router'
import LazyRoute from '@/components/LazyRoute'

export const Route = createFileRoute('/_protected/organization/settings/api-keys')({
  component: () => (
    <LazyRoute
      loader={() => import('@/components/organization-settings/api-keys')}
      fallback={<div>Loading...</div>}
    />
  ),
})